export default __webpack_public_path__ + "static/media/Flowers05.908e2d98.jpg";